const filterControl = (() => {
  const config = {
    tags: document.querySelectorAll('input[name="tags[]"]'),
    categories: document.querySelectorAll('input[name="category"'),
  };

  const showDropdown = ({ parent }) => {
    const trigger = parent.querySelector('.checkbox__toggler');
    const content = document.getElementById(
      trigger.getAttribute('aria-controls'),
    );
    const chevron = parent.querySelector('.checkbox__chevron');

    trigger.checked = true;
    content.setAttribute('aria-hidden', 'false');
    chevron.classList.add('checkbox__chevron--active');
  };

  const hideDropdown = ({ parent }) => {
    const trigger = parent.querySelector('.checkbox__toggler');
    const content = document.getElementById(
      trigger.getAttribute('aria-controls'),
    );
    const chevron = parent.querySelector('.checkbox__chevron');

    trigger.checked = false;
    content.setAttribute('aria-hidden', 'true');
    chevron.classList.remove('checkbox__chevron--active');
  };

  /* Detect which checkbox group the click was on */
  const checkClick = ({ e }) => {
    const groups = document.querySelectorAll('.checkbox__group');
    for (let i = 0; i < groups.length; i += 1) {
      const group = groups[i];
      const dropdown = group.querySelector('.checkbox__dropdown');

      if (group.contains(e.target)) {
        const toggler = group.querySelector('.checkbox__toggler');
        if (!dropdown.contains(e.target) && toggler.checked) {
          hideDropdown({ parent: group });
        } else {
          showDropdown({ parent: group });
        }
      } else {
        hideDropdown({ parent: group });
      }
    }
  };

  const uppercaseFirstLetter = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  /* Detect click inside dropdown */
  const handleCheck = ({ e }) => {
    const parentElement = e.target.closest('.checkbox__group');
    const input = parentElement.querySelector('.checkbox__status');
    const label = parentElement.querySelector('.checkbox__name');
    const checkboxes = parentElement
      .querySelector('.checkbox__dropdown')
      .querySelectorAll('input');
    const checkedBoxes = [];
    for (let i = 0; i < checkboxes.length; i += 1) {
      const checkbox = checkboxes[i];
      if (checkbox.checked) {
        checkedBoxes.push(checkbox.value);
      }
    }

    if (checkedBoxes.length > 0) {
      input.classList.add('checkbox__status--active');
      label.classList.add('checkbox__name--active');
      if (e.target.getAttribute('name') === 'category') {
        checkedBoxes[0] =
          checkedBoxes[0].toLowerCase() === 'all'
            ? (checkedBoxes[0] = 'Allt innehåll')
            : checkedBoxes[0];
        parentElement.querySelector(
          '.checkbox__status',
        ).value = `${uppercaseFirstLetter(checkedBoxes[0])}`;
        hideDropdown({ parent: parentElement });
      } else {
        parentElement.querySelector(
          '.checkbox__status',
        ).value = `${checkedBoxes.length} valda`;
      }
    } else {
      parentElement.querySelector('.checkbox__status').value = ``;
      input.classList.remove('checkbox__status--active');
      label.classList.remove('checkbox__name--active');
    }
  };

  const init = () => {
    if (config.tags && config.categories) {
      document.addEventListener('click', e => checkClick({ e }));

      for (let i = 0; i < config.categories.length; i += 1) {
        const category = config.categories[i];
        category.addEventListener('change', e => handleCheck({ e }));
        category.dispatchEvent(new Event('change'));
      }

      for (let x = 0; x < config.tags.length; x += 1) {
        const tag = config.tags[x];
        tag.addEventListener('change', e => handleCheck({ e }));
        tag.dispatchEvent(new Event('change'));
      }
    }
  };

  return {
    init,
  };
})();

filterControl.init();
